import Counter from "./counter";

function Projects() {
    return (
        <div>
            <h1>
                Projects 
            </h1>
            <h3>
            - Simple Counter using ReactJS
            </h3>
            <Counter/>
        </div>
    );
    
    }
    export default Projects;